export default __webpack_public_path__ + "static/media/march-2020.e514baf3.csv";